<template>
    <div class="intro">
        <div class="image-box">
            <img class="image" :src="imgurl"/>
        </div>
        <div class="details">
            <div class="heading3">Greetings
                <div class="tiny-box"></div>
            </div>
            <div class="paragraph">
                I’m a Full Stack Software Engineer based in Blantyre, Malawi, specializing in .NET technologies with a strong focus on C#. I build scalable, performance-driven applications that blend intuitive user experiences with robust backend systems. 
            </div>
            <div class="buttons">

                <router-link to="/about" class="button-link">Know More</router-link>
            </div>
        </div>
    </div>
</template>
<script>
export default{
    data(){
        return{
            imgurl:""
        }
    },
    created(){
        this.GetProfilePicture();
    },
    methods:{
        GetProfilePicture(){
            fetch(process.env.VUE_APP_IMAGE_URL)
            .then((response) => {
                if(response.ok){
                    return response.json();
                }
            }).then((data) => {
                this.imgurl = data.avatar_url;
            }).catch(() => this.imgurl = "");
            
        }
    }
}
</script>
<style scoped>

    .tiny-box{
        display:none;
    }
    .intro{
        display: flex;
        
    }

    .image-box{
        display: flex;
        justify-content: center;
    }

    .buttons{
        margin-top:1.7rem;
    }

    .details{
        margin-top: 2rem;
        display: flex;
        flex-direction: column;
    }

    .image{
        margin:2rem;
        height:14rem;
        flex: 1;
        border-radius: var(--radius);    
    }

    @media(max-width: 950px){
        .paragraph{
            padding-right:0.8rem;
            margin-top:0.5rem;
        }

        .image, .image-box{
            height:6rem;
            width:6rem;
            border-radius:100px;
        }

        .intro{
            flex-direction: column;
            padding:0rem 1rem;

        }

        .details{
            position:relative;
        }

        .heading3{
            position:absolute;
            font-size:1.5rem;
            background-color: var(--gold);
            color:white;
            padding:0.5rem;
            border-radius:5px;

            transform: translate(5.3rem,-6rem);
            
        }

        .heading3::after{
            content:"!";
            margin-left:-0.4rem;
        }

        .tiny-box{
        display:block;
        position: absolute;
        border:1rem solid transparent;
        border-right:1rem solid var(--gold);
        transform:rotate(180deg) translate(0.5rem,0.9rem);
        }
    }

</style>